<template >


  <section>
       <!-- Content Header (Page header) -->
       <section class="content-header">
          <h1>
             VER PAPELETA
             <small>Percy</small>
          </h1>
          <ol class="breadcrumb">
             <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
             <li class="active">Ver Papeleta</li>
          </ol>
       </section>
       <!-- Main content -->
       <section class="content">
          <div class="row">
          <!-- left column -->
            <div class="col-md-12">
               <!-- general form elements -->
               <div class="box box-primary">

                <div class="box-header with-border">
                   <h3 class="box-title">Detalle:</h3>
                </div>

                  <!-- /.box-header -->
                  <!-- form start -->
                <div class="row">

                        <div class="col-md-12">


                          <div class="col-md-12">
                             <div class="form-group">
                                <label>TIPO DE PAPELETA</label>
                                <input type="text" disabled class="form-control"  placeholder="Company" :value="papeleta.descripcion">
                             </div>
                          </div>

                          <div class="col-md-12">
                             <div class="form-group">
                                <label>FEC. INICIO.</label>
                                <input type="text" disabled class="form-control"  placeholder="Company" :value="papeleta.fechaInicio">
                             </div>
                          </div>


                          <div class="col-md-12">
                             <div class="form-group">
                                <label>FEC. TERMINO</label>
                                <input type="text" disabled class="form-control"  placeholder="Company" :value="papeleta.fechaFinal">
                             </div>
                          </div>


                          <div class="col-md-12">
                             <div class="form-group">
                                <label>MOTIVO</label>
                                <input type="text" disabled class="form-control"  placeholder="Company":value="papeleta.observacion">
                             </div>
                          </div>


                          <div class="col-md-12">
                             <div class="form-group">
                                <label>FEC. REGISTRO</label>
                                <input type="text" disabled class="form-control"  placeholder="Company" :value="papeleta.registerDate">
                             </div>
                          </div>


                        <div class="col-md-12">
                             <div class="form-group">
                                <label>AUTORIZACIÓN</label>
                                <input type="text" disabled class="form-control"  placeholder="Company" :value="papeleta.estado">
                             </div>
                          </div>


                          <div class="col-md-12">
                             <div class="form-group">
                                <label>SINC.RELOJ</label>
                                <input type="text" disabled class="form-control"  placeholder="Company" :value="papeleta.estadoReloj">
                             </div>
                          </div>
                           <!--
                            <button class="btn btn-light">
                             <i class="fa fa-trash"> Eliminar</i>
                           </button>
                        -->

                        </div>
                </div>


                  <br>



               </div>
               <!-- /.box -->
            </div>

        </div>
     </section>
  </section>


</template>
<script>
export default {
  name : 'PapeletasVer',
  data(){
    return {

    }
  },
  computed: {
    papeleta() {
      return this.$store.getters.papeleta_seleccionada
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/PapeletasVer.vue